import React, { Fragment } from 'react'

// icons
import { faCalculator } from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'
import ItemListaPrecioEliminado from './ItemListaPrecioEliminados'

// route
import { withRouter } from 'react-router-dom'

// services
import routes from '../../Routes'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import usePagination from './hooks/usePagination'
import HeaderPagination from '../Custom/HeaderPagination'

const visibleButtons = {
    create: false,
    import: false,
    export: false,
    deleted: false,
    search: true,
}

const ListasPreciosEliminados = ({ history }) => {
    
    const {
        listasPrecios,
        setIsLoad,
        page,
        totalRegister,
        totalPage,
        nextPage,
        previousPage,
        handleBuscador,
    } = usePagination(history, false)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCalculator} title={'Lista de Precios'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.LISTA_PRECIOS}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                />
                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Porcentaje Marcacion</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listasPrecios.map((lista) => (
                            <ItemListaPrecioEliminado
                                key={parseInt(lista.id)}
                                lista={lista}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(ListasPreciosEliminados)
